import request from "./request";

//公告列表
export const noticeList = (params) =>
  request({ url: "/system/notice/list", method: "get", params });
  
//设为已读
export const readStatus = (data) =>
  request({ url: "/system/notice/setIsRead", method: "post", data });